module.exports = __webpack_public_path__ + "static/media/Bedroom6-1.7be070ec.jpg";